export const AUTH_NAMESPACE = 'auth'
export const AUTH_REQUEST = 'authRequest'
export const AUTH_REQUEST_LOADING = 'authRequestLoading'
export const AUTH_SUCCESS = 'authSuccess'
export const AUTH_ERROR = 'authError'
export const AUTH_STATUS_ERROR = 'authStatusError'
export const AUTH_LOGOUT = 'authLogout'
export const AUTH_AUTHENTICATED = 'isAuthenticated'
export const AUTH_STATUS = 'authStatus'
export const AUTH_FIRST_CHECK_LOGGED = 'authFirstCheckLogged'



// WEBPACK FOOTER //
// ./src/store/actions/auth.js